
<template lang="pug">
q-modal(
  v-model="visible"
  minimized
  no-backdrop-dismiss
)
  .shifts-estimates-re.q-ma-md

    .q-mb-lg
      q-input(
        v-model="model.re1"
        type="number"
        stack-label="レーンレジ"
      )

      q-input(
        v-model="model.re2"
        type="number"
        stack-label="セミセルフレジ"
      )

      q-input(
        v-model="model.re3"
        type="number"
        stack-label="カウンターレジ"
      )

      q-input(
        v-model="model.re4"
        type="number"
        stack-label="概算用"
      )

    .row.reverse.reverse-wrap
      q-btn.q-mx-sm(
        color="dark"
        flat
        v-close-overlay
      ) キャンセル

      q-btn.q-mx-sm(
        color="primary"
        flat
        @click="confirm"
      ) 確定

</template>

<script>
import {isEmpty} from 'lodash-es'

const defaults = Object.entries({
  re1: 20,
  re2: 20,
  re3: 20,
  re4: 20,
})

export default {

  data() {
    return {
      visible: false,

      model: {},
      original: {},
    }
  },

  computed: {
    difference() {
    // modelの変更部分を抽出する
      return Object.entries(this.model).reduce((a, [k, v]) => ({...a, ...v !== this.original[k] ? {[k] : v} : {}}), {})
    },
  },

  methods: {
    show(data = {}) {
      this.model = defaults.reduce((acc, [key, val]) => ({...acc,
        [key]: key in data ? data[key] : val,
      }), {})

      this.original = {...this.model}
      this.visible = true
    },

    hide() {
      this.visible = false
    },

    confirm() {
      if(isEmpty(this.difference)) {
      // 変更がなければ、単に閉じる
        this.visible = false
      }
      else {
      // 変更があれば、confirmイベントを送信する
        this.$emit('confirm', this.difference)
      }
    },
  },
}
</script>

<style lang="sass">
.shifts-estimates-re
  width: 300px
</style>
